import { dbClient, normalizeRpcResponse } from '@/services/db-client';
import { downloadCsv } from '@/utils/downloadCsv';

interface AttributionExportRow {
  public_id: string;
  status: string;
  ccaa: string;
  modality: string;
  duration: string;
  created_at: string;
  paid_at: string | null;
  refunded_at: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;
  entry_path: string | null;
  referrer_host: string | null;
  first_touch_at: string | null;
}

const COLUMNS: (keyof AttributionExportRow)[] = [
  'public_id',
  'status',
  'ccaa',
  'modality',
  'duration',
  'created_at',
  'paid_at',
  'refunded_at',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'entry_path',
  'referrer_host',
  'first_touch_at',
];

/** Export de pedidos con origen y fechas (sin email ni datos del solicitante). */
export async function exportLicenseAttributionCsv(): Promise<number> {
  const { data, error } = await dbClient.rpc<AttributionExportRow>(
    'admin_license_orders_attribution_export',
    {}
  );
  if (error) throw new Error(error.message);
  const rows = normalizeRpcResponse(data) as AttributionExportRow[];
  const body = rows.map((r) => COLUMNS.map((c) => (r[c] == null ? '' : String(r[c]))));
  const day = new Date().toISOString().slice(0, 10);
  downloadCsv(`licencias_origen_${day}.csv`, [COLUMNS as string[], ...body]);
  return rows.length;
}
